import { Alert, AppBar, Backdrop, Box, Button, ButtonGroup, CircularProgress, Modal, Paper, Toolbar, Tooltip, Typography } from "@mui/material";
import { LoadState } from "../../../../redux/common";
import { useAppDispatch } from "../../../../app/hooks";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { RootState } from "../../../../app/store";
import { PermissionId } from "../../../../app/permissions";
import PermissionsList from "./PermissionsList";
import { useMemo, useState } from "react";
import { createInviteSlice, executeCreateInvite } from "../../../../redux/user/createInviteSlice";

export interface ModalCreateInviteProps {
    open: boolean;
    close: () => void;
    targetId: string;
    permissions: PermissionId[];
}

const ModalCreateInvite = (props: ModalCreateInviteProps) => {
    const dispatch = useAppDispatch();
    const createInvite = useSelector((state: RootState) => state.createInvite);
    
    const [permissionsToAdd, setPermissionsToAdd] = useState<PermissionId[]>([]);
    const addPermission = (id: PermissionId) => {
        if(!permissionsToAdd.includes(id)) {
            setPermissionsToAdd( [...permissionsToAdd, id] );
        }
    };
    const removePermission = (id: PermissionId) => {
        setPermissionsToAdd( permissionsToAdd.filter( p => p !== id ) );
    };
    const statusPermission = (id: PermissionId) => {
        return permissionsToAdd.includes(id);
    };

    const close = () => {
        console.log("Cleaning up the code");
        dispatch( createInviteSlice.actions.clean() );
        props.close();
    };
    
    const enabled = useMemo(() => {
        if(permissionsToAdd.length === 0) {
            return false;
        }
        return true;
    }, [permissionsToAdd]);

    const confirm = () => {
        if(enabled) {
            dispatch(executeCreateInvite({
                targetId: props.targetId,
                permissionIds: permissionsToAdd
            }));
        }
    };

    const elToolbar = <AppBar position="static" color={"primary"} sx={{ top: "auto", bottom: 0 }}>
        <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}> Gerar Código de Convite </Typography>
            <Box sx={{ flexGrow: 1 }} />
                <ButtonGroup variant="contained" color="secondary">
                    <Tooltip title="Fechar" >
                        <Button key="close" onClick={(/* event */) => { close(); }}><CloseIcon /></Button>
                    </Tooltip>
                </ButtonGroup>
        </Toolbar>
    </AppBar>;

    return <Modal open={props.open} onClose={() => {/*do nothing*/}} 
            sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Paper sx={{ maxWidth: "1000px" }} elevation={3}>
            {elToolbar}
            <Box sx={{width: "100%", px: 5, pt: 1}}>
                <Typography variant="subtitle1" component="div" sx={{width: "100%", mb: 1}}>
                    Gerar um código de convite que pode ser utilizado por qualquer pessoa para ter acesso às permissões escolhidas abaixo.
                </Typography>
            </Box>
            <PermissionsList 
                addPermission={addPermission}
                removePermission={removePermission}
                statusPermission={statusPermission}
                permissions={props.permissions} />
            <Box sx={{width: "100%", px: 3, pt: 0}}>
                <Alert severity="warning">
                    Compartilhe este código com cuidado, qualquer pessoa que o possuir terá as permissões associadas.
                </Alert>
            </Box>
            {
            createInvite.response && 
            <Box sx={{width: "100%", px: 3}}>
                <Alert severity="success">
                    Código gerado: <b>{createInvite.response.code}</b>
                </Alert>
            </Box>
            }
            <Box width="100%" sx={{textAlign: "center"}}>
                <Button variant='contained' sx={{m:1}} onClick={() => confirm()} disabled={!enabled}>Create</Button>
                <Button variant='contained' sx={{m:1}} color='error' onClick={() => close()}>Close</Button>
            </Box>
            <Backdrop open={createInvite.state.state == LoadState.Loading} sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </Paper>
    </Modal>;
};

export default ModalCreateInvite;